import { Flex, Select, SelectProps, Typography } from "antd";
import { RefObject } from "react";
import "./ppr-dropdown-select.less";

const { Text } = Typography;

interface PprDropdownSelectType extends SelectProps {
  title: string;
  selectRef?: RefObject<any>;
}

const PprDropdownSelect = ({
  title,
  selectRef,
  ...selectProps
}: PprDropdownSelectType) => {
  return (
    <Flex vertical gap={8} className="custom-select-container">
      <Text tabIndex={0}>{title}</Text>
      <Select
        ref={selectRef}
        className="custom-select"
        {...selectProps}
        suffixIcon={<i className="fa-solid fa-chevron-down custom-arrow"></i>}
      />
    </Flex>
  );
};

export default PprDropdownSelect;
